<h3>Assessments</h3>
<div class="d-flex flex-row">
  <nav ngbNav class="nav-pills" orientation="vertical" [(activeId)]="active" #nav="ngbNav">
    <ng-container *ngFor="let domain of subjectList">
      <div [ngbNavItem]="domain" class="me-3">
        <a ngbNavLink>{{ domain }}</a>
        <ng-template ngbNavContent>
          <ng-container *ngIf="!loading">
            <sortable-table
              [headers]="headers"
              showAdd="true"
              showEdit="true"
              showDelete="true"
              [data]="data.get(domain)"
              (saveCall)="save($event, domain)"
              (delCall)="del($event)"
              [adding-data]="newRow">
            </sortable-table>
          </ng-container>
          <ng-container *ngIf="loading">
            <div class="d-flex justify-content-center">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </ng-container>
        </ng-template>
      </div>
    </ng-container>
  </nav>
  <div [ngbNavOutlet]="nav" class="ms-4 flex-grow-1"></div>
</div>
